export function CampaignListSkeleton() {
  return (
    <div className="flex flex-col gap-2" aria-busy aria-label="Carregando campanhas">
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          key={index}
          className="h-[76px] animate-pulse rounded-xl bg-white/40 shadow-[var(--shadow-list-item-warm)]"
        />
      ))}
    </div>
  )
}
